var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoNaver = function SvgLogoNaver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00C300",
    d: "M31 0c17.109 0 31 13.88 31 30.973v.054C62 48.12 48.109 62 31 62S0 48.12 0 31.027v-.054C0 13.88 13.891 0 31 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.078 31.81-8.506-12.291h-7.056v22.963h7.393V30.19l8.506 12.29h7.064V19.52h-7.401z"
  })));
};
export default SvgLogoNaver;